import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'projectResourcePlanner';

const projectResourcePlannerService = {
  getProjectResourcesByType: (type, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(type)}`,
      data,
    });
  },

  getTasksByType: (type, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/tasks/${encodeURIComponent(type)}`,
      data,
    });
  },

  updateTask: (data, simpleTaskId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/task/${encodeURIComponent(simpleTaskId)}`,
      data,
    });
  },

  getWorkHours: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/getWorkhours`,
      data,
    });
  },
};
export default projectResourcePlannerService;
